module.exports = __webpack_public_path__ + "img/img-i5gam-installnfo.eb78f041.png";